import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 417393DA-3C7F-4BF2-9283-AB1429FFA068
 * name store-24-hour
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/store-24-hour.svg
 * tags
 * - Places 
 * - Shopping 
 */
export const Store24HourIcon = createSvgIcon(<><path d="M16,12H15V10H13V7H14V9H15V7H16M11,10H9V11H11V12H8V9H10V8H8V7H11M19,7V4H5V7H2V20H10V16H14V20H22V7H19Z" /></>, 'Store24HourIcon');
export default Store24HourIcon